import ancestriesData from '../data/ancestries.json';

// Cache for loaded heritage data
let heritageCache: any[] | null = null;

/**
 * Loads all heritage (ancestry) data
 */
export async function loadAllHeritageData(): Promise<any[]> {
  if (heritageCache) {
    return heritageCache;
  }
  
  try {
    heritageCache = ancestriesData;
    return heritageCache;
  } catch (error) {
    console.error('Error loading heritage data:', error);
    return [];
  }
}

/**
 * Loads a single heritage by ID
 */
export async function loadHeritageData(heritageId: string): Promise<any | null> {
  try {
    const allHeritages = await loadAllHeritageData();
    const heritage = allHeritages.find(h => h.id === heritageId);
    return heritage || null;
  } catch (error) {
    console.error(`Error loading heritage ${heritageId}:`, error);
    return null;
  }
}

/**
 * Gets heritage options for dropdowns
 */
export async function getHeritageOptions(): Promise<Array<{value: string, label: string}>> {
  try {
    const allHeritages = await loadAllHeritageData();
    return allHeritages.map(heritage => ({
      value: heritage.id,
      label: heritage.name
    }));
  } catch (error) {
    console.error('Error getting heritage options:', error);
    return [];
  }
}